<template>
    <div class="info_box">
        <div class="flex info_head_box">
            <div class="info_head"
                 :class="item.showCount > 0 ? 'active_info' : ''"
				 v-show="item.payStatus"
                 v-for="(item,index) in statusList"
                 :key="index"
            >
                <h4>{{item.title}}</h4>
                <div class="head_content flex_1" :class="index === 0 ? 'first_box' : ''">
					<PaymentRecordImageHeader :item-detail="item"/>

                    <div class="pay_info_box">
                        <template v-if="item.id === 1">
                            <InvestorReceivablePaymentsImgInfo :itemDetail="item"
                                                     :info="detailInfo"
                                                     v-if="item.id === 1"
                            ></InvestorReceivablePaymentsImgInfo>
                        </template>
                        <template v-else>
                                <InvestorReceivablePaymentsImgInfo
                                    v-for="(listItem,index) in detailInfo[item.confirmedList]"
                                    :itemDetail="item"
                                    :info="detailInfo"
                                    :listItem="listItem"
                                    :confirmed="true"
                                    :key="index"
                                ></InvestorReceivablePaymentsImgInfo>
                                <InvestorReceivablePaymentsImgInfo
                                    v-for="(listItem,index) in detailInfo[item.requestedList]"
                                    :itemDetail="item"
                                    :info="detailInfo"
                                    :listItem="listItem"
                                    :confirmed="false"
                                    :key="index"
                                ></InvestorReceivablePaymentsImgInfo>
                        </template>
                    </div>
                </div>
                <div class="info_bottom">
                    <div v-if="index === 0" class="info_item">
                        <div class="item_content">
                            <label>{{$t("InvestorPaymentsTable.Assignment.Date")}}:</label>
                            <span>{{detailInfo.assignmentDate}}</span>
                        </div>
                        <div class="item_content">
                            <label>{{$t("InvestorPaymentsTable.Purchase.Price")}}:</label>
                            <span>{{detailInfo.settlementPrice}}</span>
                        </div>
                        <div class="item_content">
                            <label>{{$t("ReceDetail.Assignment.type")}}:</label>
                            <span>{{detailInfo.postTrade}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {investorPaymentsReceivablesApi} from "@/common/api/investorPaymentsReceivablesApi";
import InvestorReceivablePaymentsImgInfo from "@/components/templates/investor/payments/receivables/InvestorReceivablePaymentsImgInfo";
import {formatAsLocalizedDate, formatAsLocalizedEnum, formatAsMoneyAmount} from "@/common/format";
import {enumDef} from "@/common/enumDefs";
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {paymentProgress} from "@/common/utils/paymentProgress";
import PaymentRecordImageHeader from "@/components/templates/common/payments/PaymentRecordImageHeader";

export default {
    components: {
		PaymentRecordImageHeader,
		InvestorReceivablePaymentsImgInfo
    },
    props: {
        params: Object
    },
    data() {
        return {
            statusList: [
                {
                    title: this.$t("investor.payments.details.closingFee.title"),
                    showCount: 0,
                    id: 1,
                    statusKey: "closingFeePaymentStatus",
                    imgUrl1: "buyer",
                    imgUrl2: "tnp",
					payStatus: null,
					paidText: ""
                },
                {
                    title: this.$t("investor.payments.details.investorToSeller.title"),
                    showCount: 0,
                    id: 2,
                    statusKey: "buyerToSellerPaymentStatus",
                    expected: "buyerToSellerAmountExpected",
                    alreadyPaid: "buyerToSellerAmountAlreadyPaid",
                    requested: "buyerToSellerAmountRequested",
                    confirmedList: "buyerToSellerConfirmedPayments",
                    requestedList: "buyerToSellerRequestedBankTransfers",
                    imgUrl1: "buyer",
                    imgUrl2: "seller",
					payStatus: null,
					paidText: ""
                },
                {
                    title: this.$t("investor.payments.details.sellerToInvestor.title"),
                    showCount: 0,
                    id: 3,
					dueDateKey: "dueDate",
                    statusKey: "sellerToBuyerPaymentStatus",
                    expected: "sellerAmountExpected",
                    alreadyPaid: "buyerAmountAlreadyReceived",
                    confirmedList: "toBuyerConfirmedPayments",
                    imgUrl1: "seller_tnp",
                    imgUrl2: "buyer",
					payStatus: null,
					paidText: ""
                }
            ],
            detailInfo: {}
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        showInvoiceFile() {
            let pdfUrl = fileuploadApi.getPdfUrl(this.detailInfo.closingFeeInvoiceFileId);
            window.open(pdfUrl, "_blank");
        },
        getDetail() {
            investorPaymentsReceivablesApi.inspection.getDetails(this.params.data.assignmentId)
                .then(res => {
                    this.detailInfo = {
                        ...res,
                        assignmentDate: formatAsLocalizedDate(res.assignmentDate),
                        postTrade: formatAsLocalizedEnum(enumDef.postTradeType, res.postTrade),
                        settlementPrice: formatAsMoneyAmount(res.settlementPrice, { currency: res.currency }),
                        closingFeePaymentDate: formatAsLocalizedDate(res.closingFeePaymentDate),
                        closingFeeAmount: formatAsMoneyAmount(res.closingFeeAmount, { currency: res.currency })
                    };

                    this.setupPayStatus(res);
                })
                .catch(this.toast);
        },
        setupPayStatus(info) {
			this.statusList.forEach(item => {
				let paymentStatus = item.id === 1
					? paymentProgress.getStatusForFee(info[item.statusKey])
					: paymentProgress.getStatusForSettlement(info[item.dueDateKey], info[item.statusKey], info[item.alreadyPaid], info[item.requested], info[item.expected]);

				if (paymentStatus) {
					item.payStatus = paymentStatus.code;
					item.paidText = paymentStatus.name;
				}
			});
        }
    },
};
</script>

<style lang="scss" scoped>
@import "src/components/templates/investor/payments/receivables/investorReceivablePayments";
</style>